<template>
  <div class="join">
    <button class="inverse" @click="openSignUp">Join Our Community</button>
    <p class="signin-hint">
      Already have an account?
      <a href="#" @click.prevent="openSignIn">Sign in</a>
    </p>
  </div>
</template>

<script setup>
const router = useRouter();
const openSignUp = () => router.replace({hash: "#join"});
const openSignIn = () => router.replace({hash: "#sign-in"});
</script>

<style scoped>
.join {
  display: inline-block; /* shrink to fit content width */
  /* margin: 0 auto; */
  text-align: center;
}
button {
  display: inline-block;
  padding: var(--space-small) var(--space-x-large);
  font-size: clamp(var(--font-size-small), 3.2vw, var(--font-size-medium));
  font-weight: 600;
  border-radius: 9999px; /* fully rounded */
  background-color: #65fe65;
  box-shadow: var(--shadow-medium);
  background-color: var(--brand-blue);
  color: black;
  transition: background-color 0.2s ease;
}
.inverse {
  background: black;
  color: var(--base-link-color);
  border: 2px solid var(--base-link-color);
}
body:not(.narrow-window) button {
  font-size: var(--font-size-large);
}
button:hover {
  background-color: #00d080;
  background-color: var(--selected-color);
}
.signin-hint {
  margin-top: var(--space-small);
  font-size: var(--font-size-small);
}
</style>
